var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.77 22.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.75,18.32c-2.81-.65-6.24-2.31-5.23-4.48,.65,1.07,2.66,1.69,4.22,.76-4.5-1.14,2.21-8.99-3.67-13.38-1.08-.81-2.4-1.22-3.71-1.22s-2.61,.4-3.66,1.22c-5.89,4.4,.83,12.24-3.67,13.38,1.56,.92,3.58,.28,4.22-.76,1.01,2.17-2.42,3.84-5.23,4.48-2.83,.65-3.02,2.34-3.02,3.8v.65H22.76v-.66c0-1.46-.19-3.15-3.01-3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.30e9bd25c64fbe075077358a52db302e.svg";
export { ForwardRef as ReactComponent };